import React from 'react';
import { styled } from '@compiled/react';
import { Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { createObjectTypeUrl } from '@atlassian/jira-servicedesk-insight-urls/src/index.tsx';
import type { ObjectTypeGraphNode } from '../../common/types.tsx';
import { SidebarHeader } from '../../common/ui/sidebar-header/index.tsx';
import messages from './messages.tsx';

type Props = {
	objectTypeNode: ObjectTypeGraphNode;
};

export const ObjectTypeView = (props: Props) => {
	const { formatMessage } = useIntl();

	const { objectTypeNode } = props;
	const { name, icon, objectSchemaId, referenceId } = objectTypeNode;

	return (
		<Wrapper>
			<SidebarHeader
				title={name}
				iconUrl={icon}
				tooltip={formatMessage(messages.openObjectTypeDetails)}
				link={createObjectTypeUrl(objectSchemaId, referenceId)}
			/>
			<SectionMessage appearance="information">
				<Text as="p">{formatMessage(messages.maxOfTypeExceeded)}</Text>
			</SectionMessage>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	paddingTop: token('space.200'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.200'),
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const visibleForTesting = {
	Wrapper,
};
